<template>
  <vueCustomScrollbar
    class="scroll-area p-2"
    :settings="{wheelSpeed:0.5}"
  >
    <div class="d-flex justify-content-between">
      <h3>My companies</h3>
      <b-button variant="outline-secondary" size="sm" v-b-modal.createCompany>
        <b-icon icon="plus"/>
      </b-button>
    </div>
    
    <div class="d-flex justify-content-center mt-3" v-if="myCompaniesIsLoad">
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
    </div>

    <b-list-group class="mt-3">
      <b-list-group-item
        v-for="(company,i) in myCompanies"
        v-bind:key="i"
        button
        :active="activeCompany==company.id"
        @click="selectCompany(company.id)"
      >
        {{company.name}}
      </b-list-group-item>
    </b-list-group>

    <b-modal 
      id="createCompany"
      title="Create company"
      :ok-title="'Create'"
      @ok="createCompany"
    >
      <b-form-group
        id="name"
        label="Company name"
        label-for="name"
      >
        <b-form-input id="name" v-model="newCompany.name"></b-form-input>
      </b-form-group>
      <b-form-group
        id="name"
        label="Company description"
        label-for="description"
      >
        <b-form-input id="description" v-model="newCompany.description"></b-form-input>
      </b-form-group>

    </b-modal>
  </vueCustomScrollbar>
</template>

<script>
const { v4: uuidv4 } = require('uuid');
import firebase from 'firebase';
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'companiesList',
  components: {
    vueCustomScrollbar
  },
  data:function(){
    return {
      user: firebase.auth().currentUser,
      myCompanies: [],
      myCompaniesIsLoad:true,
      activeCompany:null,
      newCompany:{}
    }
  },
  methods:{
    setEmptyCompanyData(){
      this.newCompany = {
        name:'',
        description:'',
        campaigns:[],
        applications:[],
        users:[],
        server_token:uuidv4(),
      }
    },
    createCompany(bvModalEvt){

      bvModalEvt.preventDefault();//Prevent modal from closing

      let data = this.newCompany;
      data.date = new Date();
      data.creator = this.user.uid;
      data.users.push(this.user.uid);

      firebase.firestore()
      .collection('companies').add(data)
      .then((companyRef)=>{
        data.id = companyRef.id;
        //add company to user
        return firebase.firestore()
        .collection("users").doc(this.user.uid)
        .update({
          companies:firebase.firestore.FieldValue.arrayUnion(companyRef)
        })
      })
      .then(() => {
        this.$bvModal.hide('createCompany');
        this.setEmptyCompanyData();
        this.selectCompany(data.id)
      })
      .catch((error)=>{
        console.error("Error adding document: ", error);
      });
    },
    selectCompany(id){
      this.activeCompany = id;
      this.$emit('selectCompany',id);
    }
  },
  mounted(){
    this.setEmptyCompanyData();

    firebase.firestore()
    .collection("companies")
    .where("creator", "==", this.user.uid)
    .onSnapshot((querySnapshot)=>{
      this.myCompanies = [];
      querySnapshot.forEach((doc)=>{
        let company = {
          id:doc.id,
          ...doc.data()
        }
        this.myCompanies.push(company);
      });
      this.myCompaniesIsLoad = false;
    });
  }
}
</script>
<style scoped>
.scroll-area{
  height: 100vh !important;
}
.scroll-area.ps--active-y{
  padding-right: 12px !important;
}
</style>